import { memo } from "react";
import { Button } from "@/core/components/ui/button/button";
import { Card } from "@/core/components/ui/card";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { openSupportChat } from "@/core/pylon";
import { cn } from "@/core/utils/utils";

export const ActivityFeedHelpCard = memo(
  ({ isHeaderAtFullWidth }: { isHeaderAtFullWidth: boolean }) => (
    <Card className="w-full p-4">
      <Stack
        align="center"
        gap="md"
        className={cn("flex-row", {
          "flex-col items-start": isHeaderAtFullWidth,
        })}
        fullWidth
      >
        <Stack gap="xs" fullWidth>
          <Typography variant="subtitleW3" textColor="interactive">
            Not seeing what you expected?
          </Typography>
          <Typography variant="bodyW2" textColor="secondary">
            We're here to help! Click the button to chat with our team.
          </Typography>
        </Stack>
        <Button
          variant="secondary"
          size="sm"
          onClick={openSupportChat}
          className="flex-shrink-0"
        >
          Get Help
        </Button>
      </Stack>
    </Card>
  ),
);

ActivityFeedHelpCard.displayName = "ActivityFeedHelpCard";
